// extracted by mini-css-extract-plugin
export default {"confirmSection":"ContactConfirmation_confirmSection__aKsa4","confirmIcon":"ContactConfirmation_confirmIcon__Axjqk"};